<app-popover-layout class="tariff-body" *ngIf="tariffScreen === 'pricing'">
  <app-x-title-row [type]="'title'" [name]="'pricing' | translate">
    <app-x-icon-button [name]="'close-large'" (click)="dialogRef.close()"></app-x-icon-button>
  </app-x-title-row>

  <app-x-divider
    [orientation]="'horizontal'"
    style="padding-top: 1px; height: 1px; margin-bottom: 3px"
  ></app-x-divider>
  <app-x-title-row [type]="'subtitle'" [name]="'select_plan' | translate">
    <app-x-tab-panel
      [tabs]="[
        { id: '0', title: 'monthly' | translate },
        { id: '1', title: 'annually' | translate },
      ]"
      [active]="monthlyYearlyActive"
      (activeChange)="changeMontlyYearly($event)"
      [style]="'width: 120px'"
    >
    </app-x-tab-panel>
  </app-x-title-row>

  <div class="tariff-item-container"></div>

  <div class="tariff-item-container"></div>

  <div class="tariff-item-container"></div>

  <app-x-divider [orientation]="'horizontal'" [showLine]="false" [type]="'medium'"></app-x-divider>
</app-popover-layout>

<app-popover-layout class="tariff-body" *ngIf="tariffScreen === 'order'">
  <ng-container *ngIf="tariffForOrderScreen as tariff">
    <app-x-title-row [type]="'title'" [name]="'order' | translate">
      <app-x-icon-button
        [name]="'caret-left-outline-16'"
        (click)="backToTariffScreen()"
        left
      ></app-x-icon-button>
      <app-x-icon-button [name]="'close-large'" (click)="dialogRef.close()"></app-x-icon-button>
    </app-x-title-row>

    <app-x-divider
      [orientation]="'horizontal'"
      style="padding-top: 1px; height: 1px; margin-bottom: 3px"
    ></app-x-divider>

    <div class="order-items">
      <app-x-title-row
        [type]="'subtitle'"
        [name]="'ordered_plan' | translate"
        class="shrinked-title-row"
      ></app-x-title-row>

      <div style="padding: 4px 16px; align-self: stretch"></div>

      <div class="common-tariff-block">
        <app-x-title-row
          [type]="'title'"
          [name]="'discount_code' | translate"
          class="shrinked-title-row"
        ></app-x-title-row>

        <div class="input-row">
          <div class="input-box">
            <app-x-inner-input
              [disabled]="tariffForOrderScreen.discountCodeProfit"
              [(ngModel)]="discountCode"
              [placeholder]="'write_code' | translate"
            ></app-x-inner-input>
          </div>
          <app-x-button
            [style]="'filled'"
            [size]="'32'"
            [disabled]="!discountCode || tariffForOrderScreen.discountCodeProfit"
            (click)="applyDiscount(discountCode)"
            >{{ 'apply' | translate }}</app-x-button
          >
        </div>

        <div class="body-1-medium discount-label" *ngIf="tariffForOrderScreen.discountCodeProfit">
          {{ 'discount_applied' | translate }}
        </div>
      </div>

      <div class="common-tariff-block">
        <app-x-title-row
          [type]="'title'"
          [name]="'price_details' | translate"
          class="shrinked-title-row"
        ></app-x-title-row>

        <div class="general-row general-row-tariff">
          <span class="body-1-medium" style="color: rgba(0, 0, 0, 0.5)"
            >{{ 'subtotal' | translate }} {{ tariff.isYearly ? 'for 12 Months' : '' }}
          </span>

          <div class="body-1-medium" style="color: #000">
            {{ tariff.subTotal | customCurrency: 'Rp' : 'symbol' : '3.0' }}
          </div>
        </div>

        <div class="general-row general-row-tariff" *ngIf="tariff.discountCodeProfit">
          <span class="body-1-medium" style="color: rgba(0, 0, 0, 0.5)">{{ 'discount' | translate }}</span>

          <div class="body-1-medium" style="color: #1bc47d">
            {{ tariff.discountCodeProfit | customCurrency: 'Rp' : 'symbol' : '3.0' }}
          </div>
        </div>
      </div>

      <app-x-divider [orientation]="'horizontal'" [type]="'medium'"></app-x-divider>

      <div class="pay-footer">
        <div class="plan">
          <div class="two-layer-text">
            <div class="heading-2-semi-bold upper">{{ 'total' | translate }}</div>
            <div class="body-1-medium lower" *ngIf="!tariff.isYearly">
              {{ 'due_to' | translate }} {{ date30DaysFromToday | date: 'dd MMM' }}
            </div>
            <div class="body-1-medium lower" *ngIf="tariff.isYearly">
              {{ 'due_to' | translate }} {{ date1YearFromToday | date: 'dd MMM YY' }}
            </div>
          </div>

          <div class="plan-right">
            <div class="heading-2-semi-bold price">
              {{ tariff.totalPrice | customCurrency: 'Rp' : 'symbol' : '3.0' }}
            </div>
          </div>
        </div>

        <div class="button">
          <app-x-button [size]="'32'" (click)="buyTariff(tariff)">{{
            'pay' | translate
          }}</app-x-button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="payLink">
    <app-payment-overlay (openLink)="openLink()"></app-payment-overlay>
  </ng-container>
</app-popover-layout>
